import { useRouter } from 'next/router';
import { useSession } from 'next-auth/react';
import { ReactNode } from 'react';

const AuthGuardProvider = ({
  allowUnAuthenticated,
  children,
}: {
  children: ReactNode;
  allowUnAuthenticated?: boolean;
}) => {
  const router = useRouter();
  const session = useSession();
  if (allowUnAuthenticated) return <>{children}</>;
  if (session.status === 'loading') return <>{children}</>;
  if (session.status === 'authenticated') return <>{children}</>;
  if (session.status === 'unauthenticated') {
    router.replace(`/login?redirect=${encodeURIComponent(router.asPath)}`);
  }
  return <></>;
};

export default AuthGuardProvider;
